import { Icon } from '@iconify-icon/react';

interface DocsHeroSectionProps {
  badge?: string;
  title: string;
  subtitle?: string;
  description: string;
}

const DocsHeroSection: React.FC<DocsHeroSectionProps> = ({
  badge = 'DOCUMENTATION',
  title,
  subtitle,
  description,
}) => {
  return (
    <section className="bg-gradient-to-b from-gray-50 to-white px-4 py-16 sm:px-6 sm:py-20 lg:px-8">
      <div className="mx-auto max-w-7xl text-center">
        <span className="inline-flex items-center gap-2 rounded-full bg-primary-50 px-4 py-2 text-sm font-medium text-primary-700">
          <Icon icon="tabler:book" className="text-base" />
          {badge}
        </span>
        <h1 className="mt-6 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl lg:text-6xl">
          {title}
          {subtitle && <span className="mt-2 block">{subtitle}</span>}
        </h1>
        <p className="mx-auto mt-6 max-w-3xl text-lg text-gray-600 sm:text-xl">{description}</p>
      </div>
    </section>
  );
};

export default DocsHeroSection;
